import * as React from 'react';
import {FunctionComponent} from 'react';
import {Day} from './Day';
import {CalendarEvent} from '../../../../../Models/CalendarEvent';
import {isSameDay} from 'date-fns';
import {utcToZonedTime} from 'date-fns-tz';

interface OwnProps {
    days: Array<{
        number: number;
        date: Date;
    }>;
    calendarEvents: CalendarEvent[];
    onCalendarEventClick: (calendarEvent: CalendarEvent) => void;
    onCreateClick: (date: Date) => void;
}

export const Week: FunctionComponent<OwnProps> = ({days, calendarEvents, onCalendarEventClick, onCreateClick}) => {
    return (
        <div className="week">
            <div className="days">
                {days.map((day, index) => {
                    return (
                        <Day
                            key={day.number}
                            isActive={isSameDay(day.date, new Date())}
                            number={day.number}
                            calendarEvents={calendarEvents.filter((calendarEvent) => {
                                return isSameDay(
                                    utcToZonedTime(calendarEvent.startAt, calendarEvent.timezone),
                                    day.date,
                                );
                            })}
                            onCalendarEventClick={onCalendarEventClick}
                            onCreateClick={() => onCreateClick(day.date)}
                        />
                    );
                })}
            </div>
        </div>
    );
};
